import { HStack, Stack, Text } from "@chakra-ui/react";

import { Avatar } from "@/components/ui/avatar";
import { useAuthenticationContext } from "@app/auth/use-authentication-context";

interface Props {
  email: string;
  name: string;
  superuser: boolean;
}

export const UserPersona: React.FC<Props> = ({ email, name, superuser }) => {
  const { accountTitle } = useAuthenticationContext();

  return (
    <HStack key={email} gap="4" w="full" alignItems="flex-start">
      <Avatar name={name} size={{ base: "xs", lg: "sm" }} />
      <Stack gap="0" title={superuser ? "Superuser" : ""}>
        <Text fontSize={{ base: "xs", lg: "sm" }} fontWeight="medium">
          {name + `${superuser ? "⚡" : ""}`}
        </Text>
        <Text textOverflow="ellipsis" color="fg.muted" fontSize="xs">
          {accountTitle}
        </Text>
      </Stack>
    </HStack>
  );
};
